import { render, staticRenderFns } from "./productionList.vue?vue&type=template&id=c545ed62&"
import script from "./productionList.vue?vue&type=script&lang=js&"
export * from "./productionList.vue?vue&type=script&lang=js&"
import style0 from "./productionList.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports